export class DetectorModelConversionSignalBoostValidationError extends Error {}

export class DetectorModelConversionError extends Error {}

export class DetectorModelConversionNoMatchingRuleError extends Error {}
